"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InputError = _interopRequireDefault(require("./InputError.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InputError = function InputError(_ref) {
  var message = _ref.message,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    className: className
  }, message);
};
InputError.defaultProps = {
  className: 'inputError'
};
InputError.propTypes = {
  message: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
var _default = exports["default"] = InputError;